import { createContext, useState } from "react"
import { ProtectRoutesProvider } from "./ProtectRoutesContext"

export const LoginContext = createContext({ loginData: null, setLoginData: () => { }, openLoginModal: false, setOpenLoginModal: () => { }, openPasswordEntryModal: false, setOpenPasswordEntryModal: () => { } })
export const GameContext = createContext({ gameList: null, setGameList: () => { }, gameCategories: null, setGameCategories: () => { } })

export const ContextProvider = ({ children }) => {
  const [loginData, setLoginData] = useState(null)
  const [gameList, setGameList] = useState(null)
  const [gameCategories, setGameCategories] = useState(null)
  const [openLoginModal, setOpenLoginModal] = useState(null)
  const [openPasswordEntryModal, setOpenPasswordEntryModal] = useState(null)

  return (
    <ProtectRoutesProvider>
      <LoginContext.Provider value={{ loginData, setLoginData, openLoginModal, setOpenLoginModal, openPasswordEntryModal, setOpenPasswordEntryModal }}>
        <GameContext.Provider value={{ gameList, setGameList, gameCategories, setGameCategories }}>
          {children}
        </GameContext.Provider>
      </LoginContext.Provider>
    </ProtectRoutesProvider>
  )
}
